module.exports = __webpack_public_path__ + "down-cbe2cbb1.png";